import {createContext} from "react";
import {CIAMContextType} from "../types"

// @ts-ignore
export const CIAMAuthContext = createContext<CIAMContextType>();
